import api from '~/api';

export const getChannelsRequest = async (): Promise<{
  authKey: string;
  subscribeKey: string;
  channels: string[];
}> => {
  const { data } = await api.get('/v2/user/channels');
  return {
    authKey: data.auth_key,
    subscribeKey: data.subscribe_key,
    channels: data.channels,
  };
};
